import React, { useEffect, useState, useRef, useCallback } from "react";
import ReactCountryFlag from "react-country-flag";
import { isoCountries } from "./TableHelper";

import "./DemographicData.css";

function DemographicData({ userData, visible, setVisible }) {
  const [data, setData] = useState(userData || []);
  const [initialData, setInitialData] = useState();
  const [filter, setFilter] = useState("all");
  const [userCount, setUserCount] = useState(0);
  const containerRef = useRef();

  useEffect(() => {
    setInitialData(userData);
    analyzeData(userData);
    if (visible) window.addEventListener("click", handleClick);
    else window.removeEventListener("click", handleClick);
  }, [visible]);

  const handleClick = useCallback((e) => {
    if (containerRef.current && !containerRef.current.contains(e.target))
      setVisible(false);
  }, []);

  const analyzeData = (data) => {
    let temp = findUniqueCountries(data);
    let count = countOccurrences(temp, data);
    setData(rankCountries(count));
  };

  const findUniqueCountries = (data) => {
    let temp = [];

    for (let i = 0; i < data.length; i++) {
      // add a country if it hasn't appeared yet
      if (data[i].country !== null && !temp.includes(data[i].country))
        temp.push(data[i].country);
    }
    return temp;
  };

  const countOccurrences = (data, filteredUsers) => {
    let temp = {};
    let sortedTemp = [];
    setUserCount(countUsers(filteredUsers));

    // initialize object
    data.forEach((country) => {
      temp[country] = 0;
    });

    // count occurrences
    for (let i = 0; i < filteredUsers.length; i++) {
      temp[filteredUsers[i].country]++;
    }

    for (const [key] of Object.entries(temp)) {
      if (key !== "null") sortedTemp.push({ country: key, count: temp[key] });
    }

    return sortedTemp;
  };

  const countUsers = (data) => {
    let result = data.filter((user) => {
      return (
        user.status !== null &&
        user.status.toLowerCase() !== "complementary" &&
        user.status.toLowerCase() !== "disabled"
      );
    });
    return result.length;
  };

  const rankCountries = (data) => {
    data.sort((a, b) => {
      if (a.count < b.count) return 1;
      if (a.count > b.count) return -1;
      return 0;
    });

    return data;
  };

  const filterData = (window) => {
    if (window === "7") {
      setFilter("7");
      let temp = userData.slice();
      temp = temp.filter((item) => {
        return new Date().getTime() - item.activeSince < 6.048e8;
      });
      analyzeData(temp);
    } else if (window === "30") {
      setFilter("30");
      let temp = userData.slice();
      temp = temp.filter((item) => {
        return new Date().getTime() - item.activeSince < 2.592e9;
      });
      analyzeData(temp);
    } else if (window === "all") {
      setFilter("all");
      analyzeData(initialData);
    }
  };

  return (
    <div
      ref={containerRef}
      className={`demographic-data-container ${visible ? "visible" : ""}`}
    >
      <span style={{ whiteSpace: "nowrap" }}>Users by country</span>
      <div className="country-list-filter-switcher">
        <div
          className={`time-period-button smalltext ${
            filter === "7" ? "active" : ""
          }`}
          onClick={() => {
            filterData("7");
          }}
        >
          7 days
        </div>
        <div
          className={`time-period-button smalltext ${
            filter === "30" ? "active" : ""
          }`}
          onClick={() => {
            filterData("30");
          }}
        >
          30 days
        </div>
        <div
          className={`time-period-button smalltext ${
            filter === "all" ? "active" : ""
          }`}
          onClick={() => {
            filterData("all");
          }}
        >
          All time
        </div>
      </div>
      <span className="new-user-count smalltext">New users: {userCount}</span>
      <ul className="country-count-list">
        {data &&
          data.map((item, i) => {
            return (
              <li key={i} className="smalltext">
                <div>
                  <ReactCountryFlag
                    className="country-flag"
                    countryCode={item.country}
                    aria-label={`${item.country}_flag`}
                    svg
                  />
                  <span className="country-name">
                    {isoCountries[item.country]}
                    {/* {item.country} */}
                  </span>
                </div>
                <span>{item.count}</span>
              </li>
            );
          })}
      </ul>
    </div>
  );
}

export default DemographicData;
